import React, { useEffect, createElement } from 'react';
const FB_PIXEL_ID = '1398995631816434';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (FB_PIXEL_ID === 'TU_PIXEL_ID_AQUI') return;
    let loaded = false;
    const loadPixel = () => {
      if (loaded) return;
      loaded = true;
      const f: Window & typeof globalThis = window;
      const b = document;
      if (f.fbq) return;
      const n: ((...args: unknown[]) => void) & {
        callMethod?: (...args: unknown[]) => void;
        queue: unknown[];
        push: (...args: unknown[]) => void;
        loaded: boolean;
        version: string;
      } = function (...args: unknown[]) {
        if (n.callMethod) {
          n.callMethod(...args);
        } else {
          n.queue.push(args);
        }
      } as typeof n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      f.fbq = n;
      if (!f._fbq) f._fbq = n;
      const t = b.createElement('script') as HTMLScriptElement;
      t.async = true;
      t.defer = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = b.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
      window.fbq('init', FB_PIXEL_ID);
      window.fbq('track', 'PageView');
      const noscript = document.createElement('img');
      noscript.height = 1;
      noscript.width = 1;
      noscript.style.display = 'none';
      noscript.src = `https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`;
      document.body.appendChild(noscript);
      // Cleanup listeners
      window.removeEventListener('scroll', loadPixel);
      window.removeEventListener('click', loadPixel);
      window.removeEventListener('touchstart', loadPixel);
    };
    // Delay pixel load until user interaction or 5s timeout
    window.addEventListener('scroll', loadPixel, {
      once: true,
      passive: true
    });
    window.addEventListener('click', loadPixel, {
      once: true
    });
    window.addEventListener('touchstart', loadPixel, {
      once: true,
      passive: true
    });
    const timeout = setTimeout(loadPixel, 5000);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('scroll', loadPixel);
      window.removeEventListener('click', loadPixel);
      window.removeEventListener('touchstart', loadPixel);
    };
  }, []);
  return null;
}